import React, { useState, useEffect, useContext } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import { DayPicker } from "react-day-picker";
import CustomDayButton from "./datepickerComponents/CustomDayButton.jsx";
import { DataSourceContext, IsMobileContext } from "../context/contexts.jsx";
import {
    format,
    startOfTomorrow,
    max,
    min,
    isSameDay,
    startOfMonth,
    addMonths,
    differenceInCalendarDays,
    addDays,
} from "date-fns";
import { ThreeDot } from 'react-loading-indicators';
 

function isDateValid(date) {
    if (date == null) {
        return false;
    }
    return !isNaN(date.getTime());
}

const DatePicker = ({ departureAirports, destination, selectedFrom, selectedTo, onChange }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [enabledDays, setEnabledDays] = useState([]);
    const [dayPricing, setDayPricing] = useState([]);

    const dataSource = useContext(DataSourceContext);
    const [availableReturnDates, setAvailableReturnDates] = useState();
    const [activeMonth, setActiveMonth] = useState(null);

    const isMobile = useContext(IsMobileContext);
    const needsDep = dataSource.requiresDeparture !== false;

    useEffect(() => {
        if (enabledDays && enabledDays.length > 0) {
            let initialMonth = selectedFrom ? selectedFrom : min(enabledDays);
            setActiveMonth(initialMonth);
        }
    }, [selectedFrom, selectedTo, enabledDays]);

    useEffect(() => {
        async function fetchData() {
            setEnabledDays([]);
            setDayPricing({});
            if (destination && (!needsDep || departureAirports.length > 0)) {
                var destinations = await dataSource.getAvailableDates(departureAirports, destination);
                var days = Object.keys(destinations);
                setEnabledDays(days);
                setDayPricing(destinations);
            }else{
                onChange(null, null);

            }
        }
        fetchData();
    }, [departureAirports, destination,dataSource]);




    const handleDayClick = (day, modifiers) => {
        if (!selectedFrom || (selectedFrom && selectedTo)) {
            onChange(day, null);
            async function fetchData() {
                var durations = await dataSource.getReturnDates(departureAirports, destination, day);
                var returnDates = durations.map((x, i) => addDays(day, x));
                setAvailableReturnDates(returnDates);
            }
            fetchData();
        } else {
            onChange(selectedFrom, day);
        }
    };

    const onMonthChange = (day) => {
        setActiveMonth(day);
    };
    const onSelect = (selected, triggerDate, modifiers, e) => {
    }
    const getTextboxText = () => {
        if (!selectedFrom && !selectedTo) {
            return null;
        }
        var str = `${selectedFrom ? format(selectedFrom, "dd/MM/yyyy") : ""} - ${selectedTo ? format(selectedTo, "dd/MM/yyyy") : ""}`;
        return str;

    };

    function formatWeekdayName(weekday, options) {
        return format(weekday, "iii", options);
    }


    let displayFrom = min(enabledDays);
    let displayTo = max(enabledDays);
    let footer = <p></p>;

    let isOffset = false;
    let selected = undefined;
    let selectingState = "outbound";
    if (!selectedFrom && !selectedTo) {
        //Has nothing selected
        footer = (
            <button className="btn bg-secondary text-white" disabled>
                Please pick the first day.
            </button>
        );
        selected = undefined;
    } else if (selectedFrom && !selectedTo) {
        //hasSelected Outbound date

        footer = (
            <button className="btn  bg-secondary  text-white" disabled>
                Please pick your return date.
            </button>
        );
        selected = { from: selectedFrom, to: undefined };
        selectingState = "inbound";
        if (availableReturnDates) {
            displayFrom = min(availableReturnDates);
            displayTo = max(availableReturnDates);
            var isSelectedNextMonth = activeMonth?.getMonth() != selectedFrom.getMonth();

            if (isSelectedNextMonth) {
                if (isMobile) {
                    displayFrom = selectedFrom;
                    setActiveMonth(selectedFrom);
                } else {
                    isOffset = true;
                }
            }
        }
    } else if (selectedFrom && selectedTo) {
        //has both dates selected
        selectingState = "outbound";
        footer = (
            <button className="btn btn-pri" onClick={() => setIsOpen(false)}>
                Continue with {differenceInCalendarDays(selectedTo, selectedFrom)} nights
            </button>
        );
        selected = { from: selectedFrom, to: selectedTo };
    }


    let activeMonthToUse = activeMonth;
    if (!isDateValid(activeMonthToUse)) {
        activeMonthToUse = activeMonth;
    }
    /*  let enabledMonths = [];
      for (let index = 0; index < enabledDays.length; index++) {
          const day = enabledDays[index];
          var startOfMonthForAvail = startOfMonth(day);
  
          if (!enabledMonths.includes(startOfMonthForAvail)) {
              enabledMonths.push(startOfMonthForAvail);
          }
      }*/

    displayTo = addMonths(displayTo, 2);

    const getDisabledDays = (day) => {
        if (selectedFrom && !selectedTo) {
            if (availableReturnDates) {
                for (let entry of availableReturnDates) {
                    var hasMatch = isSameDay(entry, day);
                    if (hasMatch) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        } else {
            return enabledDays ? !enabledDays.some((disabledDay) => isSameDay(day, disabledDay)) : true;
        }
    };

    const disbaledMatcher = [
        { before: startOfTomorrow() },
        getDisabledDays
    ];

    footer = <div>
        {enabledDays.length > 0 && (
            <>
                <div className="text-center">
                    {footer}
                </div>
            </>
        )}
    </div>;

  

    return <PopoverInput footer={footer} disabled={(needsDep && departureAirports.length == 0) || destination == null || destination == ""} inputText={"Select Dates"} isLoading={false} filterText={getTextboxText()} isOpen={isOpen} setIsOpen={setIsOpen} doubleWidth={true}>
        <div className="text-center">
            {enabledDays.length == 0 && (
                <ThreeDot color="#009DD6" size="large" text="Loading" textColor="#009DD6" easing="ease-in-out" />
            )}
            {enabledDays.length > 0 && (
                <DayPicker
                    ISOWeek
                    mode="range"
                    captionLayout="dropdown"
                    animate
                    navLayout="around"
                    weekStartsOn={1}
                    startMonth={displayFrom}
                    endMonth={displayTo}
                    numberOfMonths={2}
                    defaultMonth={activeMonth}
                    month={activeMonthToUse}
                    selected={selected}
                    disabled={disbaledMatcher}
                    onDayClick={handleDayClick}
                    onMonthChange={onMonthChange}
                    onSelect={onSelect}
                    components={{
                        DayButton: (props) => {
                            const datestring = format(props.day.date, "yyyy-MM-dd");
                            const price = dayPricing[datestring];
                            return CustomDayButton(props, price, !(selectedFrom && !selectedTo));
                        },
                    }}
                    formatters={{
                        formatWeekdayName: formatWeekdayName,
                    }}
                    classNames={{
                        "months": "rdp-months justify-center"
                    }}
                />
            )}
        </div>
    </PopoverInput>
}
export default DatePicker;
